import { TRPCClientError } from "@trpc/client";
import {
  ROSTER_IDENTITY_CONFLICT_ERROR_CODE,
  ROSTER_NAME_MATCH_ERROR_CODE,
  type RosterIdentityConflictCause,
} from "@api/shared-runtime/roster-provider-match";

/** The API forwards BAD_REQUEST causes on `shape.data.cause`. */
const readErrorCause = (error: unknown): { code?: string } | undefined => {
  if (!(error instanceof TRPCClientError)) {
    return undefined;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (error as any)?.shape?.data?.cause;
};

/** The NPI or email already belongs to a provider on this roster. */
export function parseRosterIdentityConflict(
  error: unknown,
): RosterIdentityConflictCause | null {
  const cause = readErrorCause(error);
  if (cause?.code !== ROSTER_IDENTITY_CONFLICT_ERROR_CODE) {
    return null;
  }
  return cause as RosterIdentityConflictCause;
}

/** Providers with the same last name exist that the user has not reviewed. */
export function isRosterNameMatchError(error: unknown): boolean {
  return readErrorCause(error)?.code === ROSTER_NAME_MATCH_ERROR_CODE;
}
